const template117 = {
  logo: 'https://support.rizee.in/files/stdomnic1.png',
  fallbackLetter: 'D',
  brandName: 'Domnics',
  brandTag: 'Group of Educational Institutions',
  schools: [
    { name: 'St. Domnics High School',   area: 'Saleem Nagar, Malakpet'       },
    { name: 'St. Martins High School',   area: 'RK Puram, Saroornagar'        },
    { name: 'Daisy Flower High School',  area: 'Karmanghat, Hyderabad'        },
    { name: 'Learning Tree Pre-School',  area: 'Gayathri Nagar, Karmanghat'   },
  ],
  stampSize: null, // uses default CSS (full-page watermark)
};

export default template117;
